import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { login } from "../store/actions/authAction";
import Navbar from "../components/layout/Navbar";
import { message } from "antd";

const Login = () => {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const loginUser = (e) => {
    e.preventDefault();

    const user = {
      username,
      password,
    };
    if (username === "") {
      message.error("Username is must.");
    } else if (password === "") {
      message.error("Password is must.");
    } else {
      dispatch(login(user, history));
    }
  };

  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row justify-content-center align-items-center h-80vh">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="card">
              <form onSubmit={loginUser}>
                <div className="card-body m-5">
                  <h5 className="card-title mb-3">Login to Shop_cart</h5>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Username"
                      value={username}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>

                  <button className="btn btn-primary btn-sm form-control">
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
